// extracted by mini-css-extract-plugin
export default {"item-list":"FriedMobile_item-list__+nAkl","item":"FriedMobile_item__QoflU","section":"FriedMobile_section__u84Dt","category-title":"FriedMobile_category-title__uEM28"};